import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function query(_x) {
  return _query.apply(this, arguments);
}

function _query() {
  _query = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/delivery-traking/' + queryParams.id,
              method: 'GET'
            });

          case 4:
            response = _context.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _query.apply(this, arguments);
}